import { Button } from '@apex/component-library'
import React from 'react'
import { FaInfoCircle } from 'react-icons/fa'
import {
  CaseStateDetailsWebDto,
  CaseStateScoreDetailsWebDto,
} from '../../../../api/types'
import {
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  VisuallyHidden,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
} from '@chakra-ui/react'

export interface RecommendedActionModalProps {
  caseStates: CaseStateDetailsWebDto[]
}

const RecommendedActionModal = ({
  caseStates,
}: RecommendedActionModalProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Button
        onClick={onOpen}
        variant={'link'}
        minW={1}
        h={'1rem'}
        rounded={'full'}
      >
        <VisuallyHidden>View Recommended Action Scoring Info</VisuallyHidden>
        <Icon as={FaInfoCircle} />
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Scoring</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Table variant="simple">
              <VisuallyHidden as={TableCaption}>
                Scoring Info for Recommended Action
              </VisuallyHidden>
              <Thead>
                <Tr>
                  <Th>Type</Th>
                  <Th>Results</Th>
                  <Th>Notes</Th>
                </Tr>
              </Thead>
              <Tbody>
                {caseStates.map((caseState: CaseStateDetailsWebDto) => {
                  return caseState.scores.map(
                    (score: CaseStateScoreDetailsWebDto, index: number) => {
                      return (
                        <Tr key={index}>
                          <Td>{score.scoreType}</Td>
                          <Td>{score.result}</Td>
                          <Td>{score.notes}</Td>
                        </Tr>
                      )
                    }
                  )
                })}
              </Tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose} variant="white">
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default RecommendedActionModal
